import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AIConversation from "./routes/AIConversation";

export default store => {
  return {
    path: "ai",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([import(/* webpackChunkName: "ai" */ "./components")]).then(
          ([importedModule0]) => {
            const component = importedModule0.default;
            return component;
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [AIConversation(store)],
  };
};
